import script from "./UserFileUploadPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserFileUploadPop.vue?vue&type=script&setup=true&lang=ts"

import "./UserFileUploadPop.vue?vue&type=style&index=0&id=759ae711&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-759ae711"]])

export default __exports__